// Small DOM helpers shared by the embed widgets.

/** The top-level document (widgets run inside the storefront TOP window). */
export function getTopDocument() {
  try { if (window.top && window.top !== window) return window.top.document; } catch (e) { /* cross-origin */ }
  return document;
}

export function getTopBody() {
  var doc = getTopDocument();
  return doc.body || doc.getElementsByTagName('body')[0];
}

/** HTML-escape a string for safe innerHTML interpolation. */
export function esc(s) {
  if (s == null) return '';
  var d = document.createElement('div');
  d.textContent = String(s);
  return d.innerHTML;
}

/**
 * Detect the OE Commerce content editor / backoffice, where embeds must NOT run
 * (they'd mount plugins that hijack the editor's own Bootstrap chrome). Keyed off
 * editor CHROME in the DOM — NOT window.ContentEddietor, which ships on every live
 * storefront page too. Mirrors the guard hardened in the standalone oil-guide.
 */
export function isContentEditor() {
  try {
    if (document.querySelector('.editor-side-menu, .stencil-drop-item, #content-edit-modal, body.editor-open, html.editor-open')) return true;
    var host = (window.location && window.location.hostname) || '';
    if (/^backoffice\./i.test(host)) return true;
  } catch (e) { /* ignore, assume storefront */ }
  return false;
}

/**
 * Resolve the current product SKU from the page. `selector` overrides the default
 * (#product-sku). Checks the element's data-sku / value / value-attr, then any
 * [data-sku] on the page. Shared by every product-detail widget.
 */
export function getSku(selector) {
  var doc = getTopDocument();
  var el = doc.querySelector(selector || '#product-sku');
  if (el) {
    var sku = el.getAttribute('data-sku') || (el.value && el.value.trim()) || el.getAttribute('value');
    if (sku && sku.trim()) return sku.trim();
  }
  var anySku = doc.querySelector('[data-sku]');
  if (anySku) {
    var s = anySku.getAttribute('data-sku');
    if (s && s.trim()) return s.trim();
  }
  return '';
}

/**
 * Run `fn` once the DOM is ready. Bundle is normally loaded near the end of the
 * body, but guard for the `loading` state anyway.
 */
export function onReady(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn, { once: true });
  } else {
    fn();
  }
}
